module.exports = __webpack_public_path__ + "static/media/Logo.6f7631c8.gif";